import { FC } from "react";
import { Route, Switch } from "react-router";

import { RouteWithSubRoutes, IRoute, paths } from "@router";
import { Redirect } from "react-router-dom";
import Jobs from "@/pages/client/JobEvaluation";
import Dashboard from "@/pages/client/Dashboard";
import { useTypedSelector } from "@/hooks";

const Routes: FC<{ routes: IRoute[] }> = ({ routes }) => {
  const { user, permissions } = useTypedSelector(state => state.auth);
  const hasJEDashboardPermission = permissions?.includes("VIEW_JE_DASHBOARD");
  return (
    <Switch>
      {routes.map(route => (
        <RouteWithSubRoutes {...route} />
      ))}

      {user?.role === "TOM_MASTER_USER" ? (
        <Route component={Dashboard} />
      ) : hasJEDashboardPermission ? (
        <Route component={Dashboard} />
      ) : (
        <Route component={Jobs} />
      )}
    </Switch>
  );
};

export default Routes;
